import { applySelectionDeadlines } from './SelectionDeadlineUtility';
import {getIncompatibleRuleForFeatures} from "../utils/ruleFormatter";
import {CategoryType} from "../model/constants";
import IsNullOrUndefined from "../utils/ObjectUtils";
import {applyBathroomLayouts} from "./BathroomLayoutUtility";
import {RulesUtility} from "./RulesUtility";

export const ImprovementRulesUtility = {
    isAvailableIfValidFor: (improvementRulesFound, categories, destinationCategory) => {
        let isAvailableIfValid = false;
        let availableIfCategory = null;
        const availableIfRules = improvementRulesFound.filter(r => r.ruleType === 'AVAILABLE_IF');

        availableIfRules.forEach(availableIfRule => {
            let originCategory = undefined;
            categories.forEach(category => {
                const foundFeature = category.features.find(feature => feature.id === availableIfRule.originId);
                if (foundFeature !== undefined){
                    originCategory = category;
                }

                if (originCategory !== undefined && foundFeature !== undefined){
                    if (originCategory.selected_feature === foundFeature.id) {
                        isAvailableIfValid = true;
                    } else {
                        availableIfCategory = originCategory;
                    }
                }
            });
        });

        if (availableIfRules.length === 0) isAvailableIfValid = true;

        if (!isAvailableIfValid && !IsNullOrUndefined(availableIfCategory)) {
            destinationCategory.availableIf = availableIfCategory.name;
        } else {
            destinationCategory.availableIf = null;
        }

        return isAvailableIfValid;
    },

    isIncompatibleWithValidFor: (improvementRulesFound, categories, destinationCategory) => {
        let isIncompatibleWithValid = true;
        let incompatibleWithFeatures = [];
        const addedFeatureIds = new Set();
        const incompatibleWithRules = improvementRulesFound.filter(r => r.ruleType === 'INCOMPATIBLE_WITH');

        incompatibleWithRules.forEach(incompatibleWithRule => {
            let originCategory = undefined;
            let originFeature = undefined;
            categories.forEach(category => {
                const foundFeature = category.features.find(feature => feature.id === incompatibleWithRule.originId);
                if (foundFeature !== undefined){
                    originCategory = category;
                    originFeature = foundFeature;
                }
            });

            if (originCategory !== undefined){
                if (originCategory.selected_feature === originFeature.id) {
                    isIncompatibleWithValid = false;
                    // Multiple rules can share the same originId when a multi-feature destination
                    // category has one rule per feature; avoid listing the same origin feature more
                    // than once (e.g. "MAMPARA DUCHA, MAMPARA DUCHA, MAMPARA DUCHA").
                    if (!addedFeatureIds.has(originFeature.id)) {
                        addedFeatureIds.add(originFeature.id);
                        incompatibleWithFeatures.push(originFeature);
                    }
                }
            }
        });

        if (!isIncompatibleWithValid) {
            destinationCategory.incompatibleWith = getIncompatibleRuleForFeatures(incompatibleWithFeatures);
        } else {
            destinationCategory.incompatibleWith = null;
        }

        return isIncompatibleWithValid;
    },

    applyImprovementRules: (improvementRules, rules, categories) => {
        applySelectionDeadlines(categories);
        // Clear incompatible saved upgrades before evaluating their dependent rules.
        applyBathroomLayouts(categories);
        categories.map(destinationCategory => {

            // Rules whose destinationId is the category itself keep blocking the whole category,
            // as before.
            const categoryRulesFound = improvementRules.filter(improvementRule =>
                improvementRule.destinationId === destinationCategory.id
            );

            if(categoryRulesFound.length > 0)
            {
                const isAvailableIfValid = ImprovementRulesUtility.isAvailableIfValidFor(categoryRulesFound, categories, destinationCategory);
                const isIncompatibleWithValid = ImprovementRulesUtility.isIncompatibleWithValidFor(categoryRulesFound, categories, destinationCategory);

                if (isAvailableIfValid && isIncompatibleWithValid) {
                    if (destinationCategory.selected_feature === 0) {
                        RulesUtility.findValidFeatureForCategory(rules, categories, destinationCategory);
                    }
                    // destinationCategory.selected_feature = destinationCategory.selected_feature !== 0 ? destinationCategory.selected_feature : destinationCategory.features[0].id;
                    destinationCategory.incompatibleWith = null;
                    destinationCategory.availableIf = null;
                } else {

                    destinationCategory.selected_feature = 0;
                }
            }
            else{
                destinationCategory.availableIf = null;
                destinationCategory.incompatibleWith = null;
            }

            // Rules whose destinationId points to a specific feature of the category must only
            // block that feature, not the whole category: the other features (and the category
            // itself) must stay available.
            destinationCategory.features.forEach(feature => {
                const featureRulesFound = improvementRules.filter(improvementRule =>
                    improvementRule.destinationId === feature.id
                );

                if (featureRulesFound.length === 0) {
                    feature.availableIf = null;
                    feature.incompatibleWith = null;
                    return;
                }

                const isFeatureAvailableIfValid = ImprovementRulesUtility.isAvailableIfValidFor(featureRulesFound, categories, feature);
                const isFeatureIncompatibleWithValid = ImprovementRulesUtility.isIncompatibleWithValidFor(featureRulesFound, categories, feature);

                if (isFeatureAvailableIfValid && isFeatureIncompatibleWithValid) {
                    feature.availableIf = null;
                    feature.incompatibleWith = null;
                } else if (destinationCategory.selected_feature === feature.id) {
                    destinationCategory.selected_feature = 0;
                }
            });
        });
        applyBathroomLayouts(categories);
        applySelectionDeadlines(categories);
    }
};
